var _a;
// src/infrastructure/config/apiConfig.ts
// Capa central de configuración de APIs por microservicio (APIM backoffice-*).
//
// Resolución de la base de cada microservicio, en orden de prioridad:
//   1. Override explícito del MS (REACT_APP_<MS>_API_URL) — para debug/rollback puntual.
//   2. Derivada de la base común de APIM (REACT_APP_APIM_BACKOFFICE_BASE_URL + "/<ms>").
//   3. Fallback al Gateway legacy (REACT_APP_SIGNO_API_URL, que YA incluye /api).
//
// Las APIs de APIM exponen las rutas NATIVAS bajo /api; por eso el prefijo /api solo
// se añade cuando el microservicio se consume por su URL dedicada (override o base común).
// Misma convención que signo-fe (REACT_APP_APIM_FRONT_BASE_URL → front/<ms>).
import { env } from "./env";
var normalizeBaseUrl = function (url) {
    return url ? url.replace(/\/+$/, "") : undefined;
};
var legacyBaseUrl = (_a = normalizeBaseUrl(env.REACT_APP_SIGNO_API_URL)) !== null && _a !== void 0 ? _a : "";
// Base común de las APIs backoffice-{servicio} en APIM (…/backoffice).
var apimBackofficeBaseUrl = normalizeBaseUrl(env.REACT_APP_APIM_BACKOFFICE_BASE_URL);
var dedicatedUrlFor = function (override, service) {
    var _a;
    return (_a = normalizeBaseUrl(override)) !== null && _a !== void 0 ? _a : (apimBackofficeBaseUrl ? "".concat(apimBackofficeBaseUrl, "/").concat(service) : undefined);
};
var withNativeApiPrefix = function (useNative, path) {
    return "".concat(useNative ? "/api" : "").concat(path);
};
var securityBaseUrl = dedicatedUrlFor(env.REACT_APP_SECURITY_API_URL, "security");
var signoBaseUrl = dedicatedUrlFor(env.REACT_APP_SIGNOAPI_API_URL, "signo");
var proveedoresBaseUrl = dedicatedUrlFor(env.REACT_APP_PROVEEDORES_API_URL, "proveedores");
var pagosBaseUrl = dedicatedUrlFor(env.REACT_APP_PAGOS_API_URL, "pagos");
export var ApiConfig = {
    /** SOLO compatibilidad legacy; no usar en llamadas nuevas. */
    baseUrl: legacyBaseUrl,
    // --- Security / Auth / Usuarios / Auditoría (Conversia.Security) ---
    securityApiBaseUrl: securityBaseUrl !== null && securityBaseUrl !== void 0 ? securityBaseUrl : legacyBaseUrl,
    securityPath: function (path) {
        return withNativeApiPrefix(Boolean(securityBaseUrl), path);
    },
    // Endpoints cuya ruta legacy (alias del Gateway Ocelot) != ruta nativa del servicio:
    securityResetPasswordPath: function () {
        return securityBaseUrl ? "/api/Auth/Password" : "/User/reset-password";
    },
    securityUsernameExistsPath: function () {
        return securityBaseUrl ? "/api/Auth/UsernameExist" : "/User/username-exists";
    },
    // --- Core signo-api (BackOffice/Company/Collectives/Forms/Master/Subscriptions/Terms) ---
    signoApiBaseUrl: signoBaseUrl !== null && signoBaseUrl !== void 0 ? signoBaseUrl : legacyBaseUrl,
    signoPath: function (path) {
        return withNativeApiPrefix(Boolean(signoBaseUrl), path);
    },
    // --- Proveedores (Conversia.Proveedores) ---
    proveedoresApiBaseUrl: proveedoresBaseUrl !== null && proveedoresBaseUrl !== void 0 ? proveedoresBaseUrl : legacyBaseUrl,
    proveedoresPath: function (path) {
        return withNativeApiPrefix(Boolean(proveedoresBaseUrl), path);
    },
    // --- Pagos / Precios (Conversia.Pagos) ---
    pagosApiBaseUrl: pagosBaseUrl !== null && pagosBaseUrl !== void 0 ? pagosBaseUrl : legacyBaseUrl,
    pagosPath: function (path) {
        return withNativeApiPrefix(Boolean(pagosBaseUrl), path);
    },
};
